import { createI18n } from "vue-i18n";
import { en } from "vuetify/locale";
import enLocale, { type MessageSchema } from "@/locales/en";

const messages = {
  en: {
    ...enLocale,
    $vuetify: {
      ...en,
    },
  },
};

export const i18n = createI18n<[MessageSchema], "en">({
  locale: "en",
  fallbackLocale: "en",
  legacy: false,
  messages,
});

declare module "vue-i18n" {
  export interface DefineLocaleMessage extends MessageSchema {}
}
